import { z } from "zod";

export type UserInfoSchema = {
  userId: string;
  company: string|null;
  userName: string;
  IsSelected: boolean;
  isAdmin: boolean;
  error: string;
  isActive: boolean;
};


export const UserSchema = z.object({
  userId: z.string().uuid().optional(),
  customerId: z.string().nullable().optional(),
  company: z.string().nullable().optional(),
  newPassword: z.string().min(8, "Password must be at least 8 characters").optional(),
  userName: z.string(),
  isActive: z.boolean().default(true),
  isAdmin: z.boolean().default(false),
  isAutoApprove: z.boolean().default(false)
})